import { useEffect, useRef, useState, InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Input from './Input';
import styles from './PasswordInput.module.css';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  className?: string;
  error?: boolean;
};

const PasswordInput = ({ className = '', error = false, ...props }: PasswordInputProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // מצב "גלוי" חי רק בזיכרון של הרכיב. ניווט מפרק את הרכיב ומאפס אותו, אבל
  // שליחה שנכשלה (סיסמה שגויה) משאירה את הטופס מורכב - ואז הסיסמה הייתה
  // נשארת חשופה על המסך בזמן שהמשתמש קורא את השגיאה. לכן כל submit מסתיר.
  useEffect(() => {
    const form = wrapperRef.current?.closest('form');
    if (!form) return;
    const hide = () => setVisible(false);
    form.addEventListener('submit', hide);
    return () => form.removeEventListener('submit', hide);
  }, []);

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <Input {...props} type={visible ? 'text' : 'password'} className={`${styles.input} ${className}`.trim()} error={error} />
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? t('hidePassword') : t('showPassword')}
        aria-pressed={visible}
      >
        {visible ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
      </button>
    </div>
  );
};

export default PasswordInput;
